export default __webpack_public_path__ + "044c8c7c5bdbc53e03ae37f2b25db5d4.png";